"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_RTL_CODES = exports.DEFAULT_FALLBACL_LOCALE = void 0;
exports.DEFAULT_FALLBACL_LOCALE = 'en';
exports.DEFAULT_RTL_CODES = [
    'ar',
    'ur',
    'pa',
    'ps',
    'sd'
];
